<template>
  <div class="advanced-search-form">
    <div class="form">
      <div class="inputs-row">
        <div class="icon-label">
          <img
            :src="require('@/assets/images/SearchPage/book.png')"
            class="label-icon"
          />
          <div class="label-text">书名</div>
          ：
        </div>
        <el-input class="left-input" v-model="form.name"></el-input>
        <div class="icon-label">
          <img
            :src="require('@/assets/images/SearchPage/folder.png')"
            class="label-icon"
          />
          <div class="label-text">分类</div>
          ：
        </div>
        <el-cascader
          v-model="form.type"
          :options="classifyList"
          :show-all-levels="false"
          :clearable="true"
          class="right-input"
          :placeholder="''"
          :props="{ checkStrictly: true }"
        >
        </el-cascader>
      </div>
      <div class="inputs-row">
        <div class="icon-label">
          <img
            :src="require('@/assets/images/SearchPage/author.png')"
            class="label-icon"
          />
          <div class="label-text">著者</div>
          ：
        </div>
        <el-input class="left-input" v-model="form.author"></el-input>
        <div class="icon-label">
          <img
            :src="require('@/assets/images/SearchPage/edition.png')"
            class="label-icon"
          />
          <div class="label-text">版本类型</div>
          ：
        </div>
        <el-select
          class="right-input"
          placeholder=""
          v-model="form.edition"
          clearable
        >
          <el-option
            v-for="item in editionList"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </div>
      <div class="inputs-row">
        <div class="icon-label">
          <img
            :src="require('@/assets/images/SearchPage/age.png')"
            class="label-icon"
          />
          <div class="label-text">成书朝代</div>
          ：
        </div>
        <el-input class="left-input" v-model="form.age"></el-input>
        <div class="icon-label">
          <img
            :src="require('@/assets/images/SearchPage/location.png')"
            class="label-icon"
          />
          <div class="label-text">馆藏地</div>
          ：
        </div>
        <el-input class="right-input" placeholder="" v-model="form.location">
        </el-input>
      </div>
      <div class="inputs-row inputs-time">
        <div class="icon-label">
          <img
            :src="require('@/assets/images/SearchPage/time.png')"
            class="label-icon"
          />
          <div class="label-text">成书区间</div>
          ：
        </div>
        <el-input
          placeholder=""
          v-model.number="form.from"
          @keyup.native="onlyNumber()"
        >
        </el-input>
        <span class="mid-text">至</span>
        <el-input
          placeholder=""
          v-model.number="form.to"
          @keyup.native="onlyNumber()"
        >
        </el-input>
      </div>
      <div class="inputs-row-wrapper">
        <div class="inputs-row">
          <div class="icon-label">
            <img
              :src="require('@/assets/images/SearchPage/content.png')"
              class="label-icon"
            />
            <div class="label-text">内容提要</div>
            ：
          </div>
          <el-input v-model="form.abstract"></el-input>
        </div>
        <my-dropdown :animation="'fade'" :autohidden="true" ref="abstractList">
          <template v-slot:title>
            <span class="add-link">后控词补充</span>
          </template>
          <template v-slot:content>
            <word-list
              @confirm="handleConfirmAbstract"
              @cancel="handleCancelAbstract"
              :wordList="form.abstract.split(' ')"
            ></word-list>
          </template>
        </my-dropdown>
      </div>
      <div class="inputs-row-wrapper">
        <div class="inputs-row">
          <div class="icon-label">
            <img
              :src="require('@/assets/images/SearchPage/list.png')"
              class="label-icon"
            />
            <div class="label-text">目录标引</div>
            ：
          </div>
          <el-input v-model="form.catalog"></el-input>
        </div>
        <my-dropdown :animation="'fade'" :autohidden="true" ref="catalogList">
          <template v-slot:title>
            <span class="add-link">后控词补充</span>
          </template>
          <template v-slot:content>
            <word-list
              @confirm="handleConfirmCatalog"
              @cancel="handleCancelCatalog"
              :wordList="form.catalog.split(' ')"
            ></word-list>
          </template>
        </my-dropdown>
      </div>
      <div class="inputs-row-wrapper">
        <div class="inputs-row">
          <div class="icon-label">
            <img
              :src="require('@/assets/images/SearchPage/all.png')"
              class="label-icon"
            />
            <div class="label-text">全文</div>
            ：
          </div>
          <el-input v-model="form.fullText"></el-input>
        </div>
        <my-dropdown :animation="'fade'" :autohidden="true" ref="fullTextList">
          <template v-slot:title>
            <span class="add-link">后控词补充</span>
          </template>
          <template v-slot:content>
            <word-list
              @confirm="handleConfirmFullText"
              @cancel="handleCancelFullText"
              :wordList="form.fullText.split(' ')"
            ></word-list>
          </template>
        </my-dropdown>
      </div>
      <div class="input-row-wrapper">
        <div class="input-row">
            <el-checkbox v-model="form.fuzzySearch">模糊匹配</el-checkbox>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="cancel-button" @click="handleReset">
        <img
          :src="require('@/assets/images/SearchPage/reset.png')"
          class="button-icon"
        />
        <span>重置条件</span>
      </button>
      <button
        data-warden-title="检索结果"
        :data-warden-info="`高级检索--${searchWord}`"
        class="confirm-button"
        @click="handleSearch"
      >
        <img
          :src="require('@/assets/images/SearchPage/search-white.png')"
          class="button-icon"
        />
        <span>检索</span>
      </button>
      <button class="cancel-button" @click="handleBack">
        <img
          :src="require('@/assets/images/SearchPage/back.png')"
          class="button-icon"
        />
        <span>返回</span>
      </button>
    </div>
  </div>
</template>

<script>
import MyDropdown from './MyDropdown.vue'
import WordList from './WordList.vue'
import MySearchDropDown from './MySearchDropDown.vue'
import { nanoid } from 'nanoid'
export default {
  components: { MyDropdown, WordList, MySearchDropDown },
  name: 'AdvancedSearchForm',
  data () {
    return {
      search: {
        title: ''
      },
      form: {
        name: '',
        author: '',
        abstract: '',
        catalog: '',
        edition: '',
        age: '',
        location: '',
        from: '',
        to: '',
        fullText: '',
        type: '',
        fuzzySearch: false
      },
      options: [
        {
          value: '北京',
          label: '北京'
        },
        {
          value: '上海',
          label: '上海'
        }
      ],
      classifyList: [],
      editionList: [],
      searchWord: ''
    }
  },
  mounted () {
    this.getClassifyList()
  },
  methods: {
    replacer (key, value) {
      if (value === '') {
        return undefined
      } else {
        return value
      }
    },
    handleReset () {
      //   console.log('reset')
      for (let key in this.form) {
        this.form[key] = ''
      }
    },
    handleSearch () {
      //   console.log(this.form.type.length)
      let typeStr = ''
      if (this.form.type instanceof Array && this.form.type.length === 1) {
        // 获取所有的子分类
        console.log(this.form.type)
        for (let i = 0; i < this.classifyList.length; i++) {
          if (this.classifyList[i].name === this.form.type[0]) {
            for (let name of this.classifyList[i].children) {
              typeStr += name.value + ' '
            }
          }
        }
      }

      if (this.form.type instanceof Array && this.form.type.length > 1) {
        typeStr = this.form.type[this.form.type.length - 1]
      }

      this.$global.advancedSearchDTO = {
        bookName: this.form.name,
        classification: typeStr,
        author: this.form.author,
        edition: this.form.edition,
        completionDynasty: this.form.age,
        librarySite: this.form.location,
        description: this.form.abstract,
        directory: this.form.catalog,
        text: this.form.fullText,
        completionTime: [
          this.form.from === '' ? -1 : this.form.from,
          this.form.to === '' ? -1 : this.form.to
        ],
        currentPage: 1,
        pageSize: 10,
        sortingMethod: '',
        reverseOrder: 0,
        exactSearch: this.form.fuzzySearch ? 0 : 1,
        userId: localStorage.getItem('userId'),
        sideBarInfo: {
          sideBarClassify: [],
          sideBarLibrarySite: [],
          sideBarDynasty: [],
          sideBarYear: [],
          sideBarEdition: [],
          sideBarAuthor: []
        }
      }
      localStorage.setItem('advancedSearchForm', JSON.stringify(this.form))
      // 随机生成一个唯一的ID，用于区分不同的检索结果
      let advancedSearchId = nanoid()
      this.$router.push({
        path:
          '/retrieve/advancedSearchResult?advanced=true&advancedSearchId=' +
          advancedSearchId
      })
    },
    handleBack () {
      this.$router.push({
        path: '/retrieve'
      })
    },
    handleConfirmAbstract (value) {
      let list = []
      for (let key in value) {
        list.push(...value[key])
      }
      for (let i = 0; i < list.length; i++) {
        this.form.abstract += ' ' + list[i]
      }
      this.$refs.abstractList.show = false
    },
    handleConfirmCatalog (value) {
      let list = []
      for (let key in value) {
        list.push(...value[key])
      }
      for (let i = 0; i < list.length; i++) {
        this.form.catalog += ' ' + list[i]
      }
      this.$refs.catalogList.show = false
    },
    handleConfirmFullText (value) {
      let list = []
      for (let key in value) {
        list.push(...value[key])
      }
      for (let i = 0; i < list.length; i++) {
        this.form.fullText += ' ' + list[i]
      }
      this.$refs.fullTextList.show = false
    },
    handleCancelAbstract () {
      this.$refs.abstractList.show = false
    },
    handleCancelCatalog () {
      this.$refs.catalogList.show = false
    },
    handleCancelFullText () {
      this.$refs.fullTextList.show = false
    },
    getClassifyList () {
      let url = '/retrieve/search/getClassifyList'
      let params = new URLSearchParams()
      this.$http.post(url, params).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].name === '分类') {
            this.classifyList = res.data.data[i].children
          } else if (res.data.data[i].name === '版本类型') {
            this.editionList = res.data.data[i].children
          }
        }
        for (let i = 0; i < this.classifyList.length; i++) {
          this.classifyList[i].value = this.classifyList[i].name
          this.classifyList[i].label = this.classifyList[i].name
          this.classifyList[i].children = this.classifyList[i].children.map(
            item => {
              return {
                value: item.name,
                label: item.name
              }
            }
          )
        }
      })
    },
    onlyNumber () {
      let reg = /^-?[0-9]*$/
      if (!reg.test(this.form.from)) {
        this.form.from = ''
      }
      if (!reg.test(this.form.to)) {
        this.form.to = ''
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler () {
        this.searchWord = ''
        var tempArray = [...Object.values(this.form)]
        var temp = tempArray.filter(function (s) {
          return s && (s + '').trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
        })
        this.searchWord = temp.toString()
      }
    }
  }
}
</script>

<style scoped>
.advanced-search-form {
  width: 100%;
  /* min-height: 800px; */
  background-color: #fff;
  padding: 20px 30px;
  box-sizing: border-box;
}

.form {
  padding-top: 20px;
  padding-left: 30px;
}

.inputs-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  position: relative;
  width: 785px;
}

.inputs-row.inputs-time {
  justify-content: left;
}

.inputs-time >>> .el-input {
  width: 140px;
}

.mid-text {
  margin-left: 10px;
  margin-right: 10px;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.icon-label {
  display: flex;
  align-items: center;
  justify-content: left;
}

.label-icon {
  width: 18px;
  margin-right: 7px;
}

.label-text {
  font-size: 16px;
  font-weight: bold;
  color: #634c37;
  width: 64px;
  text-align: justify;
  text-align-last: justify;
}

.advanced-search-form >>> .el-input__inner {
  height: 40px;
  border: 1px solid #634c37;
  border-radius: 0;
  color: #634c37;
  font-size: 14px;
  padding: 0 0 0 25px;
}

.advanced-search-form >>> .el-input__inner:hover {
  border: 1px solid #9e5c1d;
}

.advanced-search-form >>> .el-input__inner:focus {
  border: 1px solid #9e5c1d;
}

.advanced-search-form >>> .el-select .el-input .el-select__caret::before {
  /* content: "\e78f"; */
  color: #634c37;
  font-size: 24px;
  /* transform: translate(-50%, -50%); */
}

.advanced-search-form >>> .el-cascader .el-icon-arrow-down:before {
  /* content: "\e78f"; */
  color: #634c37;
  font-size: 24px;
  transform: translate(-50%, -50%);
}

.form {
  width: 785px;
  margin-bottom: 30px;
}

.inputs-row-wrapper {
  width: 885px;
  display: flex;
  align-items: center;
}

.add-link {
  color: #9e5c1d;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 15px;
  margin-left: 20px;
}

.left-input {
  width: 210px;
  margin-right: 40px;
}

.right-input {
  width: 307px;
}

.advanced-search-form >>> .my-dropdown-content {
  position: absolute;
  top: 50px;
  left: -680px;
}

.help-text {
  width: 162px;
  height: 382px;
  padding: 14px;
  background: rgba(244, 242, 241, 0.26);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #f4f2f1;
  text-align: left;
  margin: auto;
  margin-top: 54px;
}

.help-title {
  font-size: 16px;
  font-weight: bold;
  color: #634c37;
  margin-bottom: 10px;
}

.help-content {
  font-size: 14px;
  color: #634c37;
  line-height: 1.5;
}

.footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid #f4f2f1;
}

.cancel-button {
  width: 138px;
  height: 40px;
  background: #ffffff;
  opacity: 1;
  border: 1px solid #9e5c1d;
  color: #634c37;
  display: flex;
  align-items: center;
  margin: 0 20px;
  justify-content: center;
  cursor: pointer;
}

.confirm-button {
  width: 138px;
  height: 40px;
  background: #9e5c1d;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.confirm-button span,
.cancel-button span {
  min-width: 50px;
  width: max-content;
  text-align: justify;
  text-align-last: justify;
}

.button-icon {
  width: 24px;
  margin-right: 7px;
}

.advanced-search-form >>> .el-select-dropdown__item {
  color: #634c37;
  font-size: 14px;
}

.advanced-search-form >>> .el-select-dropdown__item.hover {
  background-color: #9e5c1d;
  color: #fff;
}

.advanced-search-form >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #9e5c1d;
  background-color: #9e5c1d;
}

.advanced-search-form .input-row>>>.el-checkbox:last-of-type {
    margin-top: 30px;
  display: flex;
    align-items: center;
  margin-right: 0;
}

.advanced-search-form .input-row >>> .el-checkbox__input+.el-checkbox__label {
    color: #634c37;
    font-size: 16px;
    font-weight: bold;
}

.advanced-search-form >>> .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #9e5c1d;
  /* font-size: 16px; */
}

.advanced-search-form >>> .el-checkbox__input.is-checked+.el-checkbox__label::before {
  border-color: #9e5c1d;
  background-color: #9e5c1d;
}
</style>



// WEBPACK FOOTER //
// src/components/AdvancedSearchForm.vue